export default "__VITE_ASSET__DkP5_QCw__"